// extracted by mini-css-extract-plugin
module.exports = {"container":"SupportPage_container__3YGeT","pageContainer":"SupportPage_pageContainer__qTeEs"};